import { Box, Stack, Typography } from '@dtx-company/design-system/src'
import { Check } from '@mui/icons-material'
import { FC } from 'react'
import { List, ListItem, ListItemIcon, ListItemText } from '@mui/material'
import { SignupProps } from '../SignupPageContainer/SignupPageContainer.types'
import { prismicImageLoader } from '@app/common/src/utils/prismicImageLoader'
import Image from 'next/image'

export const AuthPromoSection: FC<
  Pick<SignupProps, 'prismicData' | 'inviteState' | 'planContent'>
> = ({ prismicData, inviteState, planContent }) => {
  const inviteContent = inviteState?.inviteType ? prismicData?.accept_invite : undefined

  const displayContent = inviteContent || planContent || prismicData?.default

  return (
    <Stack sx={{ color: prismicData.text_color }}>
      <Typography variant="headlineSmall">{prismicData?.content_title}</Typography>

      <Box sx={theme => ({ mt: 8, minHeight: theme.spacing(30) })}>
        {!!displayContent && (
          <List disablePadding dense>
            {Object.values(displayContent?.[0]).map(content => {
              return (
                <ListItem disableGutters key={content} sx={{ p: 0, mb: 4 }}>
                  <ListItemIcon sx={theme => ({ minWidth: theme.spacing(8) })}>
                    <Check sx={{ color: prismicData.check_color }} />
                  </ListItemIcon>
                  <ListItemText sx={{ m: 0 }}>{content}</ListItemText>
                </ListItem>
              )
            })}
          </List>
        )}
      </Box>

      {!!prismicData.brand_logos && (
        <Box sx={theme => ({ maxWidth: theme.spacing(97.5), mt: 6 })}>
          <Image
            loader={prismicImageLoader}
            src={prismicData.brand_logos?.url ?? ''}
            alt={prismicData.brand_logos.alt || 'Brands using Flowcode'}
            width={390}
            height={36}
            style={{ width: '100%', height: 'auto' }}
          />
        </Box>
      )}
    </Stack>
  )
}
